import {createAction, props} from "@ngrx/store";
import {CustomerModel, FilterKeyValuePairInterface, PaginationInfoInterface} from "../../interfaces";

export const addCustomer = createAction("[Customer] Add Customer", props<{customer: CustomerModel}>());

export const addCustomers = createAction("[Customer] Add Customers", props<{customers: Array<CustomerModel>}>());

export const updateCustomer = createAction("[Customer] Update Customer", props<{customer: CustomerModel}>());

export const setCustomers = createAction("[Customer] Set Customers", props<{customers: Array<CustomerModel>}>());

export const setPaginatedCustomers = createAction("[Customer] Set Paginated Customers", props<{customers: Array<CustomerModel>}>());

export const setCustomersPaginationInfo = createAction(
  "[Customer] Set PaginationInfo",
  props<{paginationInfo: PaginationInfoInterface}>()
);

export const gotoCustomersPage = createAction("[Customer] Goto Page", props<{page: number}>());

export const applyCustomersFilters = createAction(
  "[Customer} Apply Filter",
  props<{filters: Array<FilterKeyValuePairInterface>}>()
);
